import messages from '@src/common/messages.json';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';

export const getTinStatusError = (res) => {
  const data = res.data || {};
  const statusCode = res.status;
  const { faultCode } = data;

  if (res.status === 409 && data.faultCode === 'EPTSCS') {
    throw {
      statusCode,
      faultCode,
      message: messages.TIN_EXISTS_SAME_USER,
    };
  }

  if (res.status === 409 && data.faultCode === 'EPTSCD') {
    throw {
      statusCode,
      faultCode,
      message: messages.TIN_EXISTS_DIFFERENT_USER,
    };
  }

  if (res.status === 500 && data.faultCode === 'EPTSEE') {
    throw {
      statusCode,
      faultCode,
      message: messages.TIN_STATUS_FAILED,
    };
  }

  throw res;
};

export const uploadDocumentError = (res) => {
  const data = res.data || {};
  const statusCode = res.status;
  const { faultCode } = data;

  if (res.status === 500) {
    throw {
      statusCode,
      faultCode,
    };
  }

  if (res.status === 400) {
    throw {
      statusCode,
      faultCode,
    };
  }
  throw res;
};

export const submitTinError = (res) => {
  const data = res.data || {};
  const statusCode = res.status;
  const { faultCode } = data;

  if (res.status === 500 && data.faultCode === 'EPTREE') {
    throw {
      statusCode,
      faultCode,
      message: messages.TIN_SUBMISSION_FAILED,
    };
  }

  throw res;
};

export const updateTinError = (res) => {
  const data = res.data || {};
  const statusCode = res.status;
  const { faultCode } = data;
  const { duration, endpoint, message } = res;
  const errorData = {
    status: faultCode,
    message,
    code: statusCode,
    duration,
    endpoint,
  };
  eapmEvent('EAPM_TRANSACTION_ERROR', errorData);

  if (res.status === 500) {
    throw {
      statusCode,
      faultCode,
      message: messages.TIN_SUBMISSION_FAILED,
    };
  }

  throw res;
};

export const validationError = (res) => {
  const data = res.data || {};
  const statusCode = res.status;
  const { faultCode } = data;
  const { duration, endpoint, message } = res;
  const errorData = {
    status: faultCode,
    message,
    code: statusCode,
    duration,
    endpoint,
  };
  eapmEvent('EAPM_TRANSACTION_ERROR', errorData);

  if (res.status !== 400) {
    throw {
      statusCode: 500,
      faultCode,
      message: messages.BILLING_TIN,
    };
  }

  throw res;
};
